import React, { useEffect, useContext }  from 'react';
import { LayoutContext } from '../../layouts/UserLayout';
import IntlMessages from '../../utils/IntlMessages';

const Dashboard = (menuId) => {
     const { setPageTitle } = useContext(LayoutContext);

  useEffect(() => {
    setPageTitle(<IntlMessages id={menuId.menuId} />);
    return () => setPageTitle(""); 
  }, [setPageTitle]);

  return (
    <div className="p-3">
      <h3>Welcome to Admin Dashboard</h3>
      <p>This is the main admin panel content area.</p>
    </div>
  );
};

export default Dashboard;
